import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import qs from "qs";
import { ApiConstant, LangConstant, SystemConstant, KeyConstant } from "const";
import { ApiUtils, HumpUtils, SystemUtils, StorageUtils } from "utils";
import { useQueryClient } from "react-query";

export default function useUpdateUser() {
  const { t: getLabel } = useTranslation();
  const queryClient = useQueryClient();

  const changePasswordAsyncMutation = useMutation({
    mutationFn: async data => {
      const response = await ApiUtils.createApiWithToken(false).post(
        ApiConstant.CHANGE_PASSWORD,
        qs.stringify(HumpUtils.decamelizeKeys(data)),
      );
      return response.data;
    },
    onMutate: () => {
      SystemUtils.openCircleLoading();
    },
    onSettled: () => {
      SystemUtils.openCircleLoading(false);
    },
    onSuccess: async response => {
      if (response.status === ApiConstant.STT_OK) {
        await ApiUtils.apiCreateUserActivitiesLog(SystemConstant.LOGGER_ACTION_TYPES.CHANGE_PASSWORD);
      }
    },
    onError: error => {
      console.error(error);
      SystemUtils.appendNotification(getLabel(LangConstant.TXT_UPDATE_ERROR), "error");
    },
  });

  const changePassword = async payload => {
    return changePasswordAsyncMutation.mutateAsync(payload);
  };

  const changePermission = async (isAdmin, userId) => {
    const response = await changePasswordAsyncMutation.mutateAsync({
      isAdmin,
      userId: userId,
      oldPassword: null,
      newPassword: null,
      username: StorageUtils.getStoreData(KeyConstant.KEY_USERNAME),
    });

    if (response.status === ApiConstant.STT_OK) {
      SystemUtils.appendNotification(getLabel(LangConstant.TXT_UPDATE_SUCCESS), "success");
      await queryClient.invalidateQueries({ queryKey: [ApiConstant.REACT_QUERY_KEYS.getUserList] });
      return response.data.password;
    } else {
      SystemUtils.appendNotification(getLabel(LangConstant.TXT_UPDATE_ERROR), "error");
    }
  };

  return { changePassword, changePermission };
}
